export default __webpack_public_path__ + "static/media/IconDesc_AssemblyDirectorSystem.256.be75133d.png";